
import Vue from "vue";

export default Vue.extend({
    props: {
        supportEmail: {
            type: String,
            required: true,
        },
        supportEmailHref: {
            type: String,
            required: true,
        },
    },
});
